/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Collapse,
  Divider,
  Space,
  Tag,
  Modal,
  Table,
  Rate,
  Flex,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import ExchangeDetailsDropdown from "../ExchangeD/ExchangeDetailsDropdown";
import { Link, useNavigate, useParams } from "react-router-dom";
import ExchangeStages from "../ExchangeStages";
import Step3DetailsSection from "./Step3DetailsSection";
import Step4DetailsSection from "./Step4DetailsSection";
import ExchangeEvaluationMultiStep from "../ExchangeEvaluationMultiStep";
import dayjs from "dayjs";
import { formatIndianCurrency } from "../../../../../utills/helpers";

import Step2DetailsSection from "./Step2DetailsSection";

const { Title, Text } = Typography;

const Step1DetailsSection = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [key, setKey] = useState("");
  const navigate = useNavigate();

  const handleKey = (e) => {
    setKey(e);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsPage, setShowDetailsPage] = useState(false);
  const [isValueHistoryModalVisible, setIsValueHistoryModalVisible] =
    useState(false);
  const [fileList, setFileList] = useState({
    back_image: [],
    side_image: [],
    front_image: [],
    inside_image: [],
    bank_statement: [],
    transfer_document: [],
  });

  const dateFormat = "DD/MM/YYYY";
  const roleType = useSelector((state) => state?.auth?.userData?.role);
  const leadViewDetails = useSelector((state) => state?.auth?.leadDetails);

  const setUploadComponentData = (imagesData) => {
    const formattedFileLists = {
      front_image: [],
      back_image: [],
      side_image: [],
      inside_image: [],
      transfer_document: [],
      bank_statement: [],
      copy_of_rc: [],
      copy_of_insurance: [],
      copy_of_customer_agreement: [],
    };

    imagesData?.forEach((doc) => {
      const file = {
        uid: doc.id,
        name: doc.document_file_name,
        status: "done",
        url: doc.document_path,
      };

      switch (doc.document_type) {
        case "Front":
          formattedFileLists.front_image.push(file);
          break;
        case "Back":
          formattedFileLists.back_image.push(file);
          break;
        case "Side":
          formattedFileLists.side_image.push(file);
          break;
        case "Inside":
          formattedFileLists.inside_image.push(file);
          break;
        case "Transfer":
          formattedFileLists.transfer_document.push(file);
          break;
        case "Bank Statement":
          formattedFileLists.bank_statement.push(file);
          break;
        case "Copy of RC":
        case "RC":
          formattedFileLists.copy_of_rc.push(file);
          break;
        case "Copy of Customer Agreement":
        case "Customer Agreement":
          formattedFileLists.copy_of_customer_agreement.push(file);
          break;

        // Step 2 document types
        case "engine_oil_leakage_file":
        case "coolant_leakage_file":
        case "radiator_damage_file":
        case "starter_motor_defect_file":
        case "engine_noise_file":
        case "low_pickup_file":
        case "engine_smoke_file":
        case "defective_belts_file":
        case "engine_replaced_endorsed_file":
        case "rough_engine_file":
        case "engine_rpm_defect_file":
        case "brake_disk_damage_file":
        case "brake_defect_file":
        case "abs_ebd_defect_file":
        case "keyless_cylinder_defect_file":
        case "warning_lamp_defect_file":
        case "infotainment_system_defect_file":
        case "head_lamp_defect_file":
        case "fog_lamp_defect_file":
        case "horn_defect_file":
        case "wiper_defect_file":
        case "navigation_system_defect_file":
        case "analog_music_system_defect_file":
        case "cruise_control_defect_file":
        case "steering_wheel_control_defect_file":
        case "electronic_mirror_defect_file":
        case "battery_defect_file":
        case "music_system_defect_file":
        case "power_window_defect_file":
        case "auto_headlight_wiper_defect_file":
        case "electronic_tailgate_defect_file":
        case "ac_defective_file":
        case "roof_ac_file":
        case "ventilated_seat_defect_file":
        case "electronic_seat_defect_file":
        case "paddle_shift_defect_file":
        case "tyre_pressuring_monitoring_system_defect_file":
        case "sun_roof_defect_file":
        case "rear_view_mirror_irvm_file":
        case "rear_view_mirror_orvm_file":
          break;
        // Step 3 document types
        case "clutch_defect_file":
        case "transmission_oil_leak_file":
        case "shift_shock_time_lag_file":
        case "gearbox_defect_file":
        case "drive_shaft_defect_file":
        case "boot_cut_file":
        case "differential_noise_file":
        case "wheel_noise_defect_file":
        case "modified_suspension_file":
        case "steering_noise_file":
        case "steering_oil_leak_file":
        case "steering_shaft_boot_cut_file":
        case "jammed_steering_file":
        case "defective_telescopic_tilt_file":
        case "rh_rocker_panel_file":
        case "lh_rocker_panel_file":
        case "rh_rear_fender_panel_file":
        case "lh_rear_fender_panel_file":
        case "end_panel_file":
        case "jack_tools_kit_file":
        case "door_lock_defect_file":
        case "carpet_upholstery_file":
        case "original_accessories_file":
        case "front_tyre_left_file":
        case "front_tyre_right_file":
        case "back_tyre_left_file":
        case "back_tyre_right_file":
        case "spare_wheels_file":
        case "front_spoiler_file":
        case "front_bumper_file":
        case "grill_file":
        case "rear_bumper_file":
        case "rear_spoiler_file":
        case "head_light_file":
        case "tail_light_file":
        case "fog_lamp_file":
        case "side_mirror_file":
        case "mud_flap_file":
        case "windshield_glass_file":
        case "wheel_cover_file":
        case "weather_strip_file":
        case "logo_missing_file":
        case "exterior_front_paint_file":
        case "exterior_left_paint_file":
        case "exterior_right_paint_file":
        case "exterior_rear_paint_file":
        case "exterior_top_paint_file":
          break;
        // Step 4 document types
        case "abnormal_noise_file":
        case "pedal_handling_defect_file":
        case "alignment_file":
        case "shock_absorber_defect_file":
        case "seat_belt_lock_file":
        case "drive_mode_faulty_file":
        case "lane_assist_defect_file":
        case "hill_assist_defect_file":
        case "replaced_front_door_panel_file":
        case "replaced_rear_door_panel_file":
        case "replaced_front_fender_panel_file":
        case "replaced_bonnet_hood_panel_file":
        case "replaced_trunk_hood_panel_file":
        case "front_cross_member_file":
        case "upper_core_support_file":
        case "core_support_file":
        case "rear_wheel_house_file":
        case "front_side_member_file":
        case "front_inside_panel_file":
        case "front_pillar_file":
        case "center_pillar_file":
        case "roof_panel_file":
        case "dash_panel_file":
        case "floor_cross_member_file":
        case "floor_side_member_file":
        case "center_floor_panel_file":
        case "rear_side_member_file":
        case "rear_floor_panel_file":
        case "rear_inside_panel_file":
        case "rear_cross_member_file":
        case "driver_seat_file":
        case "co_driver_seat_file":
        case "rear_seats_file":
        case "sunroof_file":
        case "wireless_charger_file":
        case "cup_holders_file":
        case "glove_box_file":
        case "front_ac_file":
        case "rear_ac_file":
        case "front_floor_mat_file":
        case "rear_floor_mat_file":
        case "seat_belts_front_file":
        case "seat_belts_rear_file":
        case "door_handles_front_file":
        case "door_handles_rear_file":
        case "interior_cleaning_file":
          // For Step 2, 3, and 4 files, we'll store them in a generic way
          // The renderFileLinks function will handle them by document_type
          break;
        default:
          break;
      }
    });

    setFileList(formattedFileLists);
  };

  useEffect(() => {
    if (leadViewDetails?.documents) {
      setUploadComponentData(leadViewDetails.documents);
    }
  }, [leadViewDetails?.documents]);

  const getDocumentsByType = (documentTypes) => {
    if (!Array.isArray(documentTypes)) {
      documentTypes = [documentTypes];
    }
    return (
      leadViewDetails?.documents?.filter((doc) =>
        documentTypes.includes(doc.document_type)
      ) || []
    );
  };

  const renderFileLinks = (documentTypes, showLabel = true) => {
    const files = getDocumentsByType(documentTypes);
    if (files && files.length > 0) {
      return (
        <div style={{ marginTop: showLabel ? "8px" : "4px" }}>
          <div style={{ marginTop: "4px" }}>
            {files.map((file, index) => (
              <div key={index} style={{ marginBottom: "2px" }}>
                <a
                  href={file.document_path}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "11px",
                    color: "#1890ff",
                    textDecoration: "none",
                    display: "inline-block",
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  📎 {file.document_file_name}
                </a>
              </div>
            ))}
          </div>
        </div>
      );
    }
    if (showLabel) {
      return (
        <p className="value" style={{ fontStyle: "italic" }}>
          No file uploaded
        </p>
      );
    }
    return null;
  };

  const formatValue = (value, type = "text") => {
    if (value === null || value === undefined || value === "") {
      return <p className="value">N/A</p>;
    }

    switch (type) {
      case "currency":
        return <p className="value">{formatIndianCurrency(value)}</p>;
      case "date":
        return <p className="value">{dayjs(value).format("DD/MM/YYYY")}</p>;
      case "boolean":
        return (
          <Tag
            color={
              value === "Yes" ? "green" : value === "No" ? "red" : "default"
            }
            style={{ fontSize: "10px", margin: 0 }}
          >
            {value}
          </Tag>
        );
      default:
        return <p className="value">{value}</p>;
    }
  };

  const DetailItem = ({
    label,
    value,
    type = "text",
    files = null,
    cost = null,
    icon = null,
    onIconClick = null,
  }) => (
    <Flex align="center">
      <Flex align="center" className="view-fields w-100">
        <h6>
          {label}:{" "}
          {icon && (
            <Button
              type="text"
              size="small"
              icon={icon}
              onClick={onIconClick}
              style={{
                height: "auto",
                fontSize: "12px",
              }}
            />
          )}
        </h6>

        {formatValue(value, type)}
      </Flex>
      {cost && (
        <Flex className=" w-100">
          <Flex align="center" className="view-fields w-100">
            <h6>Cost:</h6>

            <Flex align="center" gap={10}>
              {formatValue(cost, "currency")}
              {files && renderFileLinks(files, false)}
            </Flex>
          </Flex>
        </Flex>
      )}
    </Flex>
  );

  const DetailFileItem = ({ label, filePath, filePathName }) => (
    <Flex>
      <Flex align="center" className="view-fields w-100">
        <h6>{label}:</h6>

        {filePath ? (
          <div style={{ marginTop: "4px" }}>
            <a
              href={filePath}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: "11px",
                color: "#1890ff",
                textDecoration: "none",
                display: "inline-block",
                maxWidth: "60%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {filePathName || "Transfer Document"}
            </a>
          </div>
        ) : (
          <p
            className="value"
            style={{
              fontStyle: "italic",
            }}
          >
            No file uploaded
          </p>
        )}
      </Flex>
    </Flex>
  );

  const DetailRenderFileItem = ({ label, renderFileLink }) => (
    <Flex>
      <Flex align="center" className="view-fields w-100">
        <h6>{label}:</h6>
        {renderFileLink}
      </Flex>
    </Flex>
  );
  const vehicleDetail = leadViewDetails?.exchange_vehicle_detail;
  const functionalDetail =
    leadViewDetails?.exchange_vehicle_functional_evaluation_detail;

  // Prepare data for the value history table
  const valueHistoryColumns = [
    {
      title: "Exchange Value",
      dataIndex: "exchange_value",
      key: "exchange_value",
      render: (value) => formatIndianCurrency(value),
    },
    {
      title: "Offered By",
      dataIndex: "created_by",
      key: "created_by",
      render: (createdBy) => createdBy?.full_name || "N/A",
    },
  ];

  const valueHistoryData =
    leadViewDetails?.exchange_offered_value_history || [];

  return (
    <>
      {key === "" ? (
        <div className="user-data lead-detail">
          <ExchangeStages leadViewDetails={leadViewDetails} />

          <div className="personal-detail">
            <div className="detail-wrapper">
              <div className="view-input-field">
                <div style={{ marginTop: "20px" }}>
                  <Collapse
                    defaultActiveKey={[]}
                    size="large"
                    items={[
                      {
                        key: "step1",
                        label: (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{ fontWeight: "600", fontSize: "20px" }}
                            >
                              Vehicle Insurance & Basic Details
                            </span>
                          </div>
                        ),
                        children: (
                          <div style={{ padding: "16px 0" }}>
                            <Row gutter={[24, 24]}>
                              {/* Section 1 - Vehicle Details (15 fields) */}
                              <Col xs={24} sm={12} md={12} lg={12}>
                                <DetailItem
                                  label="Make"
                                  value={vehicleDetail?.make?.title}
                                />
                                <DetailItem
                                  label="Model"
                                  value={vehicleDetail?.model?.model_name}
                                />
                                <DetailItem
                                  label="Car Variant"
                                  value={vehicleDetail?.variant?.variant_code}
                                />
                                <DetailItem
                                  label="Year"
                                  value={vehicleDetail?.car_year}
                                />
                                <DetailItem
                                  label="Fuel"
                                  value={vehicleDetail?.fuel_type?.title}
                                />
                                <DetailItem
                                  label="Transmission"
                                  value={vehicleDetail?.transmission?.name}
                                />
                                <DetailItem
                                  label="RC NUMBER"
                                  value={vehicleDetail?.rc_number}
                                />
                                <DetailItem
                                  label="Emission Type"
                                  value={vehicleDetail?.emission_type}
                                />
                                <DetailItem
                                  label="Warranty Applicability"
                                  value={vehicleDetail?.warranty_applicability}
                                />

                                <Flex align="center">
                                  <Flex
                                    align="center"
                                    className="view-fields w-100"
                                  >
                                    <h6> Rating of Car:</h6>
                                    {vehicleDetail?.car_rating ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                          flex: 1,
                                        }}
                                      >
                                        <Rate
                                          count={5}
                                          value={vehicleDetail.car_rating}
                                          disabled={true}
                                          allowHalf={false}
                                          style={{ fontSize: "14px" }}
                                        />
                                        <p className="value">
                                          ({vehicleDetail.car_rating}/5)
                                        </p>
                                      </div>
                                    ) : (
                                      <p className="value"> N/A </p>
                                    )}
                                  </Flex>
                                </Flex>

                                <DetailItem
                                  label="Number of Owners"
                                  value={
                                    functionalDetail?.no_of_owners ||
                                    vehicleDetail?.no_of_owners
                                  }
                                />
                                <DetailItem
                                  label="VIN Number"
                                  value={
                                    functionalDetail?.vin_number ||
                                    vehicleDetail?.vin_number
                                  }
                                />
                                <DetailItem
                                  label="VIN Plate Available"
                                  value={functionalDetail?.vin_plate_available}
                                  type="boolean"
                                  // files={functionalDetail?.vin_plate_available === 'Yes' ? ['Vin Plate'] : null}
                                />
                                <DetailItem
                                  label="Engine Number"
                                  value={functionalDetail?.engine_number}
                                />
                                <DetailItem
                                  label="RC Book Type"
                                  value={functionalDetail?.rc_book_type}
                                />
                              </Col>

                              {/* Section 2 - Registration & Service Details (15 fields) */}
                              <Col xs={24} sm={12} md={12} lg={12}>
                                <DetailItem
                                  label="Registration Date"
                                  value={functionalDetail?.registration_date}
                                  type="date"
                                />
                                <DetailItem
                                  label="Reregistered/Migrated"
                                  value={
                                    functionalDetail?.reregistered_migrated
                                  }
                                  type="boolean"
                                />
                                <DetailItem
                                  label="Engine Capacity"
                                  value={functionalDetail?.engine_capacity}
                                />
                                <DetailItem
                                  label="Number of cylinders"
                                  value={functionalDetail?.no_of_cylinders}
                                />
                                <DetailItem
                                  label="Odometer"
                                  value={vehicleDetail?.odometer}
                                />
                                <DetailItem
                                  label="AC Configuration"
                                  value={functionalDetail?.ac_configuration}
                                />
                                <DetailItem
                                  label="HP Entry"
                                  value={functionalDetail?.hp_entry}
                                  type="boolean"
                                />
                                <DetailItem
                                  label="NOC Available"
                                  value={functionalDetail?.noc_available}
                                  type="boolean"
                                />
                                <DetailItem
                                  label="HP Bank"
                                  value={functionalDetail?.bank_detail?.name}
                                />
                                <DetailItem
                                  label="Original Invoice Available"
                                  value={
                                    functionalDetail?.original_invoice_available
                                  }
                                  type="boolean"
                                />
                                <DetailItem
                                  label="Owner's Manual Available"
                                  value={
                                    functionalDetail?.owners_manual_available
                                  }
                                  type="boolean"
                                />
                                <DetailItem
                                  label="Tools Available"
                                  value={functionalDetail?.tools_available}
                                  type="boolean"
                                />
                                <DetailItem
                                  label="Service History Available"
                                  value={
                                    functionalDetail?.service_history_available
                                  }
                                  type="boolean"
                                />
                                <DetailItem
                                  label="Legal Case Present"
                                  value={functionalDetail?.legal_case_present}
                                  type="boolean"
                                />
                                <DetailItem
                                  label="Last Service Date"
                                  value={functionalDetail?.last_service_date}
                                  type="date"
                                />
                                <DetailItem
                                  label="Number of Seats"
                                  value={functionalDetail?.no_of_seats}
                                />
                              </Col>

                              {/* Section 3 - Insurance & Financial Details (15 fields) */}
                              <Col xs={24} sm={12} md={12} lg={12}>
                                <DetailItem
                                  label="Customer Type"
                                  value={vehicleDetail?.customer_type}
                                />
                                <DetailItem
                                  label="Name as on RC Card"
                                  value={functionalDetail?.name_as_on_rc_card}
                                />
                                <DetailItem
                                  label="Expected Price"
                                  value={vehicleDetail?.expected_price}
                                  type="currency"
                                />
                                <DetailItem
                                  label="Insurance Type"
                                  value={vehicleDetail?.insurance_type}
                                />
                                <DetailItem
                                  label="Insurance Premium"
                                  value={vehicleDetail?.insurance_premium}
                                  type="currency"
                                />
                                <DetailItem
                                  label="Insurance Validity"
                                  value={vehicleDetail?.insurance_validity}
                                  type="date"
                                />
                                <DetailItem
                                  label="Company Name"
                                  value={vehicleDetail?.company_name}
                                />
                                <DetailItem
                                  label="Policy Number"
                                  value={vehicleDetail?.policy_number}
                                />
                                <DetailItem
                                  label="IDV Value"
                                  value={vehicleDetail?.idv_value}
                                  type="currency"
                                />
                                <DetailItem
                                  label="NCB Details"
                                  value={vehicleDetail?.ncb_details}
                                />
                                <DetailItem
                                  label="Insurance Cost"
                                  value={vehicleDetail?.insurance_cost}
                                  type="currency"
                                />
                                <DetailItem
                                  label="Bank"
                                  value={vehicleDetail?.bank_detail?.name}
                                />
                                <DetailItem
                                  label="Outstanding Loan"
                                  value={vehicleDetail?.outstanding_loan}
                                  type="currency"
                                />
                                <DetailItem
                                  label="Foreclosure Loan"
                                  value={vehicleDetail?.foreclose_loan}
                                  type="boolean"
                                  // cost={vehicleDetail?.foreclose_loan === 'Yes' ? vehicleDetail?.foreclosure_amount_paid_by_dealer : null}
                                />
                                <DetailItem
                                  label="Foreclosure Amount Paid By dealer"
                                  value={
                                    vehicleDetail?.foreclose_loan === "Yes"
                                      ? vehicleDetail?.foreclosure_amount_paid_by_dealer
                                      : 0
                                  }
                                  type="currency"
                                />
                              </Col>

                              {/* Section 4 - Valuation & Documents (15 fields) */}
                              <Col xs={24} sm={12} md={12} lg={12}>
                                <DetailItem
                                  label="OBV Purchase Value"
                                  value={vehicleDetail?.obv_purchase_value}
                                  type="currency"
                                />
                                <DetailItem
                                  label="Broker Valuation"
                                  value={vehicleDetail?.broker_valuation}
                                  type="currency"
                                />
                                <DetailItem
                                  label="Value Offered"
                                  value={vehicleDetail?.value_offered}
                                  type="currency"
                                  icon={<InfoCircleOutlined />}
                                  onIconClick={() =>
                                    setIsValueHistoryModalVisible(true)
                                  }
                                />
                                <DetailItem
                                  label="Next Follow Up Date"
                                  value={vehicleDetail?.next_follow_up_date}
                                  type="date"
                                />
                                <DetailItem
                                  label="Follow Up Status"
                                  value={
                                    vehicleDetail?.exchange_followup_status
                                      ?.name
                                  }
                                />
                                <DetailItem
                                  label="City Registrations/Documents"
                                  value={
                                    functionalDetail?.city_registrations_document
                                  }
                                  type="boolean"
                                  cost={
                                    functionalDetail?.city_registrations_document ===
                                    "Yes"
                                      ? functionalDetail?.city_registrations_document_cost
                                      : null
                                  }
                                  files={
                                    functionalDetail?.city_registrations_document ===
                                    "Yes"
                                      ? [
                                          "City Registrations Document",
                                          "City Registration",
                                        ]
                                      : null
                                  }
                                />
                                <DetailItem
                                  label="Accessories in Case of Repairs"
                                  value={functionalDetail?.accessories_repairs}
                                  type="boolean"
                                  cost={
                                    functionalDetail?.accessories_repairs ===
                                    "Yes"
                                      ? functionalDetail?.accessories_repairs_cost
                                      : null
                                  }
                                  files={
                                    functionalDetail?.accessories_repairs ===
                                    "Yes"
                                      ? [
                                          "Accessories Repairs",
                                          "Accessories Repairs Document",
                                        ]
                                      : null
                                  }
                                />
                                <DetailItem
                                  label="One Time Road Tax Paid"
                                  value={
                                    functionalDetail?.one_time_road_tax_paid
                                  }
                                  type="boolean"
                                />
                                <DetailFileItem
                                  label="Transfer Document"
                                  filePath={
                                    vehicleDetail?.transfer_document_file_path
                                  }
                                  filePathName={
                                    vehicleDetail?.transfer_document_file_name
                                  }
                                />
                                <DetailFileItem
                                  label="Loan Statement"
                                  filePath={
                                    vehicleDetail?.bank_statement_file_path
                                  }
                                  filePathName={
                                    vehicleDetail?.bank_statement_file_name
                                  }
                                />
                                <DetailRenderFileItem
                                  label="Copy of RC"
                                  renderFileLink={renderFileLinks([
                                    "Copy of RC",
                                    "RC",
                                  ])}
                                />
                                <DetailRenderFileItem
                                  label="Customer Agreement"
                                  renderFileLink={renderFileLinks([
                                    "Copy of Customer Agreement",
                                    "Customer Agreement",
                                  ])}
                                />
                                <DetailRenderFileItem
                                  label="Insurance Document"
                                  renderFileLink={renderFileLinks([
                                    "Insurance Policy",
                                    "Insurance Document",
                                  ])}
                                />
                                <DetailRenderFileItem
                                  label="Vin Plate Document"
                                  renderFileLink={renderFileLinks([
                                    "Vin Plate",
                                  ])}
                                />

                                {/* <div style={{ marginBottom: "12px" }}>
                                  <Text
                                    strong
                                    style={{
                                      fontSize: "13px",
                                      color: "#262626",
                                    }}
                                  >
                                    Transfer Document:
                                  </Text>
                                  {vehicleDetail?.transfer_document_file_path ? (
                                    <div style={{ marginTop: "4px" }}>
                                      <a
                                        href={
                                          vehicleDetail.transfer_document_file_path
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          fontSize: "11px",
                                          color: "#1890ff",
                                          textDecoration: "none",
                                          display: "inline-block",
                                          maxWidth: "200px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {vehicleDetail?.transfer_document_file_name ||
                                          "Transfer Document"}
                                      </a>
                                    </div>
                                  ) : (
                                    <Text
                                      style={{
                                        fontSize: "11px",
                                        color: "#999",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      No file uploaded
                                    </Text>
                                  )}
                                </div> */}
                                {/* <div style={{ marginBottom: "12px" }}>
                                  <Text
                                    strong
                                    style={{
                                      fontSize: "13px",
                                      color: "#262626",
                                    }}
                                  >
                                    Loan Statement:
                                  </Text>
                                  {vehicleDetail?.bank_statement_file_path ? (
                                    <div style={{ marginTop: "4px" }}>
                                      <a
                                        href={
                                          vehicleDetail.bank_statement_file_path
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          fontSize: "11px",
                                          color: "#1890ff",
                                          textDecoration: "none",
                                          display: "inline-block",
                                          maxWidth: "200px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {vehicleDetail?.bank_statement_file_name ||
                                          "Loan Statement"}
                                      </a>
                                    </div>
                                  ) : (
                                    <Text
                                      style={{
                                        fontSize: "11px",
                                        color: "#999",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      No file uploaded
                                    </Text>
                                  )}
                                </div> */}

                                {/* <Flex
                                  align="center"
                                  className="view-fields w-100"
                                >
                                  <h6>Copy of RC:</h6>
                                  {renderFileLinks(["Copy of RC", "RC"])}
                                </Flex> */}

                                {/* <div style={{ marginBottom: "12px" }}>
                                  <Text
                                    strong
                                    style={{
                                      fontSize: "13px",
                                      color: "#262626",
                                    }}
                                  >
                                    Customer Agreement:
                                  </Text>
                                  {renderFileLinks([
                                    "Copy of Customer Agreement",
                                    "Customer Agreement",
                                  ])}
                                </div> */}
                                {/* <div style={{ marginBottom: "12px" }}>
                                  <Text
                                    strong
                                    style={{
                                      fontSize: "13px",
                                      color: "#262626",
                                    }}
                                  >
                                    Insurance Document:
                                  </Text>
                                  {renderFileLinks([
                                    "Insurance Policy",
                                    "Insurance Document",
                                  ])}
                                </div> */}
                                {/* <div style={{ marginBottom: "12px" }}>
                                  <Text
                                    strong
                                    style={{
                                      fontSize: "13px",
                                      color: "#262626",
                                    }}
                                  >
                                    Vin Plate Document:
                                  </Text>
                                  {renderFileLinks(["Vin Plate"])}
                                </div> */}
                              </Col>
                            </Row>

                            {/* Additional Documents Section */}
                            <Row
                              gutter={[24, 24]}
                              style={{ marginTop: "24px" }}
                            >
                              <Col xs={24}>
                                <Row>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="Engine Number Document"
                                      renderFileLink={renderFileLinks([
                                        "Engine Number",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Engine Number Document:
                                      </Text>
                                      {renderFileLinks(["Engine Number"])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="Odometer File"
                                      renderFileLink={renderFileLinks([
                                        "Odometer Reading",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Odometer File:
                                      </Text>
                                      {renderFileLinks(["Odometer Reading"])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="City Registrations Document"
                                      renderFileLink={renderFileLinks([
                                        "City Registrations Document",
                                        "City Registration",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        City Registrations Document:
                                      </Text>
                                      {renderFileLinks([
                                        "City Registrations Document",
                                        "City Registration",
                                      ])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="Accessories Repairs Document"
                                      renderFileLink={renderFileLinks([
                                        "Accessories Repairs",
                                        "Accessories Repairs Document",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Accessories Repairs Document:
                                      </Text>
                                      {renderFileLinks([
                                        "Accessories Repairs",
                                        "Accessories Repairs Document",
                                      ])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label=" Exterior Front"
                                      renderFileLink={renderFileLinks([
                                        "Exterior Front",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Exterior Front:
                                      </Text>
                                      {renderFileLinks(["Exterior Front"])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="Exterior Back"
                                      renderFileLink={renderFileLinks([
                                        "Exterior Back",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Exterior Back:
                                      </Text>
                                      {renderFileLinks(["Exterior Back"])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label=" Exterior Left"
                                      renderFileLink={renderFileLinks([
                                        "Exterior Left",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Exterior Left:
                                      </Text>
                                      {renderFileLinks(["Exterior Left"])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label=" Exterior Right"
                                      renderFileLink={renderFileLinks([
                                        "Exterior Right",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Exterior Right:
                                      </Text>
                                      {renderFileLinks(["Exterior Right"])}
                                    </div> */}
                                  </Col>

                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="Interior Front"
                                      renderFileLink={renderFileLinks([
                                        "Interior Front",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Interior Front:
                                      </Text>
                                      {renderFileLinks(["Interior Front"])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="Interior Back"
                                      renderFileLink={renderFileLinks([
                                        "Interior Back",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Interior Back:
                                      </Text>
                                      {renderFileLinks(["Interior Back"])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="Bonnet Open"
                                      renderFileLink={renderFileLinks([
                                        "Bonnet Open",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Bonnet Open:
                                      </Text>
                                      {renderFileLinks(["Bonnet Open"])}
                                    </div> */}
                                  </Col>
                                  <Col xs={24} sm={12} md={8} lg={12}>
                                    <DetailRenderFileItem
                                      label="Boot Open"
                                      renderFileLink={renderFileLinks([
                                        "Boot Open",
                                      ])}
                                    />
                                    {/* <div style={{ marginBottom: "12px" }}>
                                      <Text
                                        strong
                                        style={{
                                          fontSize: "13px",
                                          color: "#262626",
                                        }}
                                      >
                                        Boot Open:
                                      </Text>
                                      {renderFileLinks(["Boot Open"])}
                                    </div> */}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </div>
                        ),
                      },
                      {
                        key: "step2",
                        label: (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{ fontWeight: "600", fontSize: "20px" }}
                            >
                              Functional & Brake Evaluation
                            </span>
                          </div>
                        ),
                        children: (
                          <Step2DetailsSection
                            leadViewDetails={leadViewDetails}
                            renderFileLinks={renderFileLinks}
                          />
                        ),
                      },
                      {
                        key: "step3",
                        label: (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{ fontWeight: "600", fontSize: "20px" }}
                            >
                              {" "}
                              Mechanical & Exterior Details
                            </span>
                          </div>
                        ),
                        children: (
                          <Step3DetailsSection
                            leadViewDetails={leadViewDetails}
                            renderFileLinks={renderFileLinks}
                          />
                        ),
                      },
                      {
                        key: "step4",
                        label: (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{ fontWeight: "600", fontSize: "20px" }}
                            >
                              {" "}
                              Interior & Final Inspection
                            </span>
                          </div>
                        ),
                        children: (
                          <Step4DetailsSection
                            leadViewDetails={leadViewDetails}
                            renderFileLinks={renderFileLinks}
                          />
                        ),
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
            {/* Start Inspection Button for Procurement Manager - when Pre evaluation is in progress and Quality Inspection is not started */}
            {(() => {
              const qualityInspectionNotStarted =
                leadViewDetails?.exchange_stage_history?.filter(
                  (stage) =>
                    stage.lead_exchange_stage_id === 3 && stage.status === 1
                ).length > 0;

              return (
                qualityInspectionNotStarted &&
                (roleType === "Procurement Manager" ||
                  roleType === "Super Admin") &&
                leadViewDetails?.lead_status?.name === "Open"
              );
            })() && (
              <div className="user-right d-flex align-items-center justify-content-end mt-4">
                <Button
                  type="primary"
                  className="secondary-button"
                  onClick={() => handleKey("inspection")}
                >
                  Start Inspection
                </Button>
              </div>
            )}

            {/* Start Re-evaluation Button for both roles - Quality Inspection stage */}
            {(roleType === "Exchange Evaluation Team" ||
              roleType === "Procurement Manager" ||
              roleType === "Super Admin") &&
              leadViewDetails?.lead_status?.name === "Open" &&
              leadViewDetails?.exchange_stage_history?.filter(
                (stage) =>
                  stage.lead_exchange_stage_id === 4 && stage.status === 1
              ).length > 0 && (
                <div className="user-right d-flex align-items-center justify-content-end mt-4">
                  <Button
                    type="primary"
                    className="secondary-button"
                    onClick={() => handleKey("reevaluation")}
                  >
                    Start Re-evaluation
                  </Button>
                </div>
              )}

            {/* Start Pre Final Assessment Button for both roles - when Pre Final Assessment (stage 6) is in progress */}
            {(roleType === "Exchange Evaluation Team" ||
              roleType === "Procurement Manager" ||
              roleType === "Super Admin") &&
              leadViewDetails?.lead_status?.name === "Open" &&
              leadViewDetails?.exchange_stage_history?.filter(
                (stage) =>
                  stage.lead_exchange_stage_id === 6 && stage.status === 1
              ).length > 0 && (
                <div className="user-right d-flex align-items-center justify-content-end mt-4">
                  <Button
                    type="primary"
                    className="secondary-button"
                    onClick={() => handleKey("reevaluation")}
                  >
                    Start Pre Final Assessment
                  </Button>
                </div>
              )}

            {/* Start Final Assessment Button only for Procurement Manager - when Final Assessment (stage 7) is in progress */}
            {(roleType === "Procurement Manager" ||
              roleType === "Super Admin") &&
              leadViewDetails?.lead_status?.name === "Open" &&
              leadViewDetails?.exchange_stage_history?.filter(
                (stage) =>
                  stage.lead_exchange_stage_id === 7 && stage.status === 1
              ).length > 0 && (
                <div className="user-right d-flex align-items-center justify-content-end mt-4">
                  <Button
                    type="primary"
                    className="secondary-button"
                    onClick={() => handleKey("reevaluation")}
                  >
                    Start Final Assessment
                  </Button>
                </div>
              )}
          </div>
        </div>
      ) : (
        <ExchangeEvaluationMultiStep />
      )}

      {/* Value History Modal */}
      <Modal
        title="Exchange Value History"
        open={isValueHistoryModalVisible}
        onCancel={() => setIsValueHistoryModalVisible(false)}
        footer={[
          <Button
            key="close"
            onClick={() => setIsValueHistoryModalVisible(false)}
          >
            Close
          </Button>,
        ]}
        width={600}
      >
        <Table
          columns={valueHistoryColumns}
          dataSource={valueHistoryData}
          rowKey="id"
          pagination={false}
          size="small"
        />
      </Modal>
    </>
  );
};

export default Step1DetailsSection;
